export const stateName = 'railsContext';